const homeReviews = document.querySelector(".home-reviews");
const duration = 800;
let hasEnteredViewport = false;

// Set counter text to data-target value
const setCounterToTarget = (counter) => {
  const target = counter.getAttribute("data-target");
  // console.debug("[setCounterToTarget] Setting counter to target:", target);
  counter.textContent = target;
};

// Set all counters in a NodeList to their target values immediately
const setCountersToTarget = (counters) => {
  // console.debug("[setCountersToTarget] Setting all counters to their targets");
  counters.forEach(setCounterToTarget);
};

// Animate counters and mark animation completion in sessionStorage
const animateCounters = (counters, storageKey) => {
  console.debug("[animateCounters] Starting animation for", counters.length, "counters");

  let completedCount = 0;
  const total = counters.length;

  counters.forEach(counter => {
    const target = parseInt(counter.getAttribute("data-target"), 10);

    if (isNaN(target)) {
      console.warn("[animateCounters] Invalid data-target for counter:", counter);
      completedCount++;
      return;
    }

    // Always start from 0
    counter.textContent = "0";

    const startTime = performance.now();

    const update = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(Math.max(elapsed / duration, 0), 1);

      // Clamp value so it can never go below 0
      const currentValue = Math.max(0, Math.floor(progress * target));

      counter.textContent = currentValue;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        counter.textContent = target;
        completedCount++;

        if (completedCount === total) {
          sessionStorage.setItem(storageKey, "true");
          console.debug(
            `[animateCounters] All animations complete. Set sessionStorage key: ${storageKey}`
          );
        }
      }
    };

    requestAnimationFrame(update);
  });
};

// Handle a single slide: if animated before, set values immediately, else animate
const animateCountersInSlide = (slide) => {
  if (!slide) return;

  const slideId = slide.getAttribute("data-slide-id");
  if (!slideId) return;

  const storageKey = `hasAnimated-${slideId}`;
  const counters = slide.querySelectorAll(".incrementCounter");

  if (sessionStorage.getItem(storageKey) === "true") {
    setCountersToTarget(counters);
  } else {
    // Set to 0 immediately before animation starts
    counters.forEach(counter => {
      counter.textContent = "0";
    });

    animateCounters(counters, storageKey);
  }
};

// Early check: immediately set counters for slides already animated this session
const earlySessionStorageCheck = () => {
  // console.debug("[earlySessionStorageCheck] Running early session check");
  const slides = document.querySelectorAll(".reviewcarousel .carousel-cell");
  slides.forEach(slide => {
    const slideId = slide.getAttribute("data-slide-id");
    if (!slideId) return;

    const storageKey = `hasAnimated-${slideId}`;
    if (sessionStorage.getItem(storageKey) === "true") {
      // console.debug(`[earlySessionStorageCheck] Restoring values from sessionStorage for slide: ${slideId}`);
      const counters = slide.querySelectorAll(".incrementCounter");
      setCountersToTarget(counters);
    }
  });
};

// Check and animate all selected slides when section in viewport or slide selected
const checkAndAnimateSelectedSlides = () => {
  if (!hasEnteredViewport) return;

  const selectedSlides = document.querySelectorAll(".reviewcarousel .carousel-cell.is-active");
  // console.debug(`[checkAndAnimateSelectedSlides] Animating ${selectedSlides.length} selected slides`);
  selectedSlides.forEach(animateCountersInSlide);
};

// Intersection Observer triggers when .home-reviews enters the viewport
if (homeReviews) {
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.debug("[IntersectionObserver] .home-reviews entered the viewport");
        hasEnteredViewport = true;
        checkAndAnimateSelectedSlides();
        obs.disconnect();
      }
    });
  }, { threshold: 0.1 });

  observer.observe(homeReviews);

  // Run early sessionStorage check as soon as possible (on load or immediately)
  if (document.readyState === "complete" || document.readyState === "interactive") {
    earlySessionStorageCheck();
  } else {
    window.addEventListener("DOMContentLoaded", earlySessionStorageCheck);
  }
}

// Mutation Observer watches for changes in slide selection
const reviewCells = document.querySelectorAll(".reviewcarousel .carousel-cell");

if (reviewCells.length > 0) {
  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(({ target, type }) => {
      if (type === "attributes" && target.classList.contains("is-active")) {
        // console.debug(`[MutationObserver] Slide became selected:`, target);
        checkAndAnimateSelectedSlides();
      }
    });
  });

  reviewCells.forEach(cell => {
    mutationObserver.observe(cell, {
      attributes: true,
      attributeFilter: ["class"]
    });
  });
}


document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".reviewcarousel video").forEach((video) => {

    video.muted = true;
    video.playsInline = true;

    const playVideo = () => {
      const promise = video.play();

      if (promise !== undefined) {
        promise.catch(() => {
          // Browser prevented autoplay
        });
      }
    };

    if (video.readyState >= 2) {
      playVideo();
    } else {
      video.addEventListener("loadeddata", playVideo, { once: true });
    }
  });
});